import React from "react";
import { Grid2, LinearProgress } from "@mui/material";
import { differenceInDays } from "date-fns";
import ExpireStyle from "../PlanExpire/ExpireStyle.module.scss";
import { formatDate } from "../../../../../../Utils/utils";

const PlanExpire = ({ currentPlan }) => {
  const createTimestamp = currentPlan?.creationDate;
  const expiredDate = currentPlan?.expirationDate;

  // Convert timestamps to Date objects
  const creationDate = new Date(createTimestamp);
  const expirationDate = new Date(expiredDate);

  const totalDays = differenceInDays(expirationDate, creationDate);
  const daysPassed = differenceInDays(new Date(), creationDate);
  const remainingDays = totalDays - daysPassed;

  // const formatDate = (date) =>
  //   date.toLocaleDateString("en-GB", {
  //     day: "numeric",
  //     month: "long",
  //   });

  const formattedCreateDate = formatDate(creationDate);
  const formattedEndDate = formatDate(expirationDate);

  // Calculate progress percentage for monthly and yearly plans
  const progressPercentage =
    currentPlan?.billingType === "Yearly"
      ? Math.min((daysPassed / totalDays) * 100, 100) // Yearly progress bar
      : Math.min((daysPassed / totalDays) * 100, 100); // Monthly progress bar

  // Calculate filled segments for yearly billing
  const filledSegments =
    currentPlan?.billingType === "Yearly"
      ? Math.floor((daysPassed / totalDays) * 12)
      : 0;

  return (
    <Grid2 className={ExpireStyle.container}>
      <Grid2 className={ExpireStyle.heading}>
        You're down to
        <Grid2 className={ExpireStyle.days}>
          {remainingDays > 0 ? remainingDays : 0} days
        </Grid2>
        left in this {currentPlan?.billingType} cycle.
      </Grid2>

      {/* Segmented Progress Bar for yearly billing */}
      <Grid2 className={ExpireStyle.progressBar}>
        {currentPlan?.billingType === "Yearly" ? (
          <Grid2 className={ExpireStyle.segmentContainer}>
            {Array.from({ length: 12 }).map((_, index) => (
              <Grid2
                key={index}
                className={`${ExpireStyle.segment} ${
                  index < filledSegments ? ExpireStyle.filledSegment : ""
                }`}
              />
            ))}
          </Grid2>
        ) : (
          <LinearProgress
            variant="determinate"
            value={progressPercentage}
            style={{ height: 8, borderRadius: 5 }}
          />
        )}
      </Grid2>
      <Grid2 className={ExpireStyle.dates}>
        <Grid2 className={ExpireStyle.startDate}>{formattedCreateDate}</Grid2>
        <Grid2 className={ExpireStyle.endDate}>{formattedEndDate}</Grid2>
      </Grid2>

      {currentPlan?.billingType === "Yearly" ? (
        <Grid2 className={ExpireStyle.yearBlock}>
          <Grid2>
            <Grid2 className={ExpireStyle.remainingDays}>{remainingDays}</Grid2>
            <Grid2 className={ExpireStyle.daysLeft}>Days left</Grid2>
          </Grid2>
          <Grid2 className={ExpireStyle.divide}>/</Grid2>
          <Grid2>
            <Grid2 className={ExpireStyle.totalDays}>365</Grid2>
            <Grid2 className={ExpireStyle.totalLabel}>Total Days</Grid2>
          </Grid2>
        </Grid2>
      ) : (
        <>
          <Grid2 className={ExpireStyle.yearBlock}>
            <Grid2>
              <Grid2 className={ExpireStyle.remainingDays}>
                {remainingDays}
              </Grid2>
              <Grid2 className={ExpireStyle.daysLeft}>Days left</Grid2>
            </Grid2>
          </Grid2>
          {/* <Grid2 className={ExpireStyle.annualBlock}>
            <Grid2 className={ExpireStyle.annualBlockHeading}>
              Save 16% by switching to annual billing
            </Grid2>
            <Grid2 className={ExpireStyle.annualBlockBody}>
              Save $68.00 a year by switching to our annual plan - equivalent to 2 months free!
            </Grid2>
            <Grid2 className={ExpireStyle.annualBlockButton}>
              Switch to annual billing
            </Grid2>
          </Grid2> */}
        </>
      )}
    </Grid2>
  );
};

export default PlanExpire;
